import {
  Annotation,
  Axis,
  Chart,
  G2,
  Interval,
  Legend,
  Line,
  Point,
  Tooltip,
} from 'bizcharts';
import { IEvent } from 'bizcharts/lib/interface';
import { useOrderAnalysisChart } from './provider/OrderAnalysisChartProvider';

export const OrderAnalysisChart = () => {
  const { data } = useOrderAnalysisChart();
  let chartIns: G2.Chart | null = null;
  const scale = {
    orderCount: {
      min: 0,
      tickCount: 4,
      alias: '주문횟수',
      type: 'linear-strict',
      formatter: (d: number) => `${d}회`,
    },
    orderAmount: {
      min: 0,
      tickCount: 4,
      alias: '주문총액',
      type: 'linear-strict',
      formatter: (d: number) => `${d.toLocaleString()}원`, // 금액 포맷팅 (1000 단위 쉼표 추가 및 '원' 추가)
    },
    month: {
      formatter: (d: string) => `${d}월`, // 금액 포맷팅 (1000 단위 쉼표 추가 및 '원' 추가)
    },
  };

  const colors = ['#699bff', '#fd6666'];

  return (
    data.length > 0 && (
      <div>
        <Chart
          scale={scale}
          autoFit
          height={400}
          data={data}
          // padding={[40, 80, 50, 105]}
          onGetG2Instance={(chart: G2.Chart) => {
            chartIns = chart;
          }}
        >
          <Axis
            name='orderAmount'
            title={{
              text: '주문 총액', // 제목 텍스트
              position: 'center', // 축의 끝에 제목 표시
              style: {
                fontSize: 15,

                fill: '#333',
              }, // 제목 스타일
            }}
          />
          <Axis
            name='orderCount'
            title={{
              text: '주문 횟수', // 제목 텍스트
              position: 'center', // 축의 끝에 제목 표시
              style: {
                fontSize: 15,

                fill: '#333',
              }, // 제목 스타일
            }}
          />
          <Legend
            custom={true}
            allowAllCanceled={true}
            items={[
              {
                value: 'orderAmount', // 차트에서 주문 총액에 해당하는 값
                name: '주문총액', // 주문 총액을 나타내는 레전드 이름
                marker: {
                  symbol: 'square', // 하이픈 모양의 마커
                  style: { fill: colors[0], r: 5 }, // 마커의 색상, 크기 및 선 두께
                },
              },
              {
                value: 'orderCount', // 차트에서 주문 횟수에 해당하는 값
                name: '주문횟수', // 주문횟수를 나타내는 레전드 이름
                marker: {
                  symbol: 'hyphen', // 사각형 모양의 마커
                  style: { stroke: colors[1], r: 5, lineWidth: 3 }, // 마커의 색상 및 크기
                },
              },
            ]}
            onChange={(ev: IEvent | undefined) => {
              if (!ev) return;
              if (chartIns == null) return;
              const item = ev.item;
              const value = item.value;
              const checked = !item.unchecked;
              const geoms = chartIns.geometries;

              for (let i = 0; i < geoms.length; i++) {
                const geom = geoms[i];

                if (geom.getYScale().field === value) {
                  if (checked) {
                    geom.show();
                  } else {
                    geom.hide();
                  }
                }
              }
            }}
          />
          <Tooltip shared />
          <Interval position='month*orderAmount' color={colors[0]} size={15} />
          <Line
            position='month*orderCount'
            color={colors[1]}
            size={3}
            shape='smooth'
          />
          {/* <Annotation.Text
          top
          position={{ time: '10:10', people: 0.2 }}
          style={{ textAlign: 'center', fill: 'red' }}
          content='test'
        /> */}
          <Point
            position='month*orderCount'
            color={colors[1]}
            size={3}
            shape='circle'
          />
        </Chart>
      </div>
    )
  );
};
